import { Component } from '@angular/core';
import { PageHeroComponent } from "../../../../shared/components/page-hero/page-hero.component";

@Component({
  selector: 'app-contact-hero-section',
  imports: [PageHeroComponent],
  templateUrl: './contact-hero-section.component.html',
  styleUrl: './contact-hero-section.component.css',
})
export class ContactHeroSectionComponent {

}
